module.exports = __webpack_public_path__ + "img/page5Img2.1eb9bfc4.png";